"use client"

import { motion } from "motion/react"
import { CommunityCard } from "@/components/communities/community-card"

interface CommunityGridProps {
    communities: any[]
}

export function CommunityGrid({ communities }: CommunityGridProps) {
    return (
        <motion.div
            className="flex flex-col gap-16 md:gap-24"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={{
                visible: {
                    transition: {
                        staggerChildren: 0.2
                    }
                }
            }}
        >
            {communities.map((community, index) => (
                <motion.div
                    key={community.id}
                    variants={{
                        hidden: { opacity: 0, y: 50 },
                        visible: {
                            opacity: 1,
                            y: 0,
                            transition: { duration: 0.8, ease: "easeOut" }
                        }
                    }}
                >
                    <CommunityCard
                        community={community}
                        index={index}
                    />
                </motion.div>
            ))}
        </motion.div>
    )
}
